import { chatFragment } from '../fragments';
import { makeRequest } from '../utils';

/**
 * @param {string} id
 * @param {Record} data
 * @param {string} data.isPaused
 */
export const updateChat = (id, data) =>
  makeRequest({
    operationName: 'UpdateChat',
    query: `
      mutation UpdateChat($id: String! $data: ChatUpdateInput!) {
        updateChat(id: $id, data: $data) {
          ...ChatFragment
        }
      }

      ${chatFragment}
    `,
    variables: { id, data },
  });
